<div class="modal-header-container">
  <div class="modal-title">{{configModel.title$() | translate}}</div>
  <div *ngIf="!configModel.hideCloseIcon$ || !configModel.hideCloseIcon$()" class="pi pi-times close-icon" (click)="onCloseIconClicked()"></div>
</div>
